import fetch_utils from "../fetch_utils";
import ITrads from "../ITrads";

type OdorConcentrationPointsRow = [
  // latitude
  number,
  // longitude
  number,
  // weight
  number
];

interface IIdConfigAndCheckbox {
  id: number;
  checkboxGroupHtml: HTMLDivElement;
  label: string;
  id_task: number;
  name_task:string;
  value:number;
}

interface IHeatmapAndLabel {
  heatmap: google.maps.visualization.HeatmapLayer;
  label: string;
  id: number;
  id_task: number;
  name_task:string;
  value: number;
}

interface IDistanceWeight {
  distance: number;
  weight: number;
  originalWeight: number;
}

let trads: ITrads;

const sourceEmission: google.maps.Marker[] = [];
const areaEmission: google.maps.Polygon[] = [];

/**
 * https://gis.stackexchange.com/questions/246322/get-the-inverse-of-default-heat-map-gradient-in-google-maps-javascript-api
 */
const uniteHTML = "uo<sub>E</sub>/m<sup>3</sup>";
const uniteTXT = " uoE/m3"; // On a du mettre en text car le html ne s'affichait pas dans le cadre à gauche


const gradientHeatmap = [
  "rgba(102, 255, 0, 0)",
  "rgba(102, 255, 0, 1)",
  "rgba(147, 255, 0, 1)",
  "rgba(193, 255, 0, 1)",
  "rgba(238, 255, 0, 1)",
  "rgba(244, 227, 0, 1)",
  "rgba(249, 198, 0, 1)",
  "rgba(255, 170, 0, 1)",
  "rgba(255, 113, 0, 1)",
  "rgba(255, 57, 0, 1)",
  "rgba(255, 0, 0, 1)",
];

const gradientHeatmap1 = [
  'rgba(255, 255, 255, 0)', // transparent
  'rgba(54, 97, 255, 1)',   // bleu foncé
]

const gradientHeatmap2 = [
  'rgba(255, 255, 255, 0)', // transparent
  'rgba(54, 97, 255, 1)',   // bleu foncé
  'rgba(24, 180, 241, 1)',  // bleu ciel
]

const gradientHeatmap3 = [
  'rgba(255, 255, 255, 0)', // transparent
  'rgba(54, 97, 255, 1)',   // bleu foncé
  'rgba(24, 180, 241, 1)',  // bleu ciel
  'rgba(80, 235, 95, 1)',   // vert
]

const gradientHeatmap4 = [
  'rgba(255, 255, 255, 0)', // transparent
  'rgba(54, 97, 255, 1)',   // bleu foncé
  'rgba(24, 180, 241, 1)',  // bleu ciel
  'rgba(80, 235, 95, 1)',   // vert
  'rgba(254, 230, 5, 1)',   // jaune
]

const gradientHeatmap5 = [
  'rgba(255, 255, 255, 0)', // transparent
  'rgba(54, 97, 255, 1)',   // bleu foncé
  'rgba(24, 180, 241, 1)',  // bleu ciel
  'rgba(80, 235, 95, 1)',   // vert
  'rgba(254, 230, 5, 1)',   // jaune
  'rgba(249, 159, 28, 1)',  // orange
  'rgba(238, 24, 72, 1)',   // rouge
]

const gradientHeatmap6 = [
  'rgba(255, 255, 255, 0)', // transparent
  'rgba(54, 97, 255, 1)',   // bleu foncé
  'rgba(24, 180, 241, 1)',  // bleu ciel
  'rgba(80, 235, 95, 1)',   // vert
  'rgba(254, 230, 5, 1)',   // jaune
  'rgba(249, 159, 28, 1)',  // orange
  'rgba(238, 24, 72, 1)',   // rouge
  'rgba(190, 0, 148, 1)'    // violet
]

const getProductionTaskOdor = async (date: string, time: string, aOdorModellingConfigId: number): Promise<
  {  label:string}[]
> => {
  const pathname = `/Enqueteur/modelling_odor_concentration/php/ajax_get_production_task.php?date=${date}&time=${time}&odor_modelling_config_id=${aOdorModellingConfigId}`;
  const productionTasks = await fetch_utils.boilerplateGet(pathname);
  if (productionTasks === false) {
    return;
  }
  try {
    return JSON.parse(productionTasks);
  } catch (error) {
    fetch_utils.catchJsonParseError(pathname, productionTasks);
    return [];
  }
};


const getAjaxOdorModellingConfig = async (): Promise<
  { id: number; label: string; latitude: number; longitude: number }[]
> => {
  const pathname = `/Enqueteur/modelling_odor_concentration/php/ajax_get_odor_modelling_config.php`;
  const odorModellingConfigIdsRaw = await fetch_utils.boilerplateGet(pathname);
  if (odorModellingConfigIdsRaw === false) {
    return;
  }
  try {
    return JSON.parse(odorModellingConfigIdsRaw);
  } catch (error) {
    fetch_utils.catchJsonParseError(pathname, odorModellingConfigIdsRaw);
    return [];
  }
};

const placeAreaEmission = (
  map: google.maps.Map,
  points: Array<google.maps.LatLng >
) => {
  return new google.maps.Polygon({
    paths: points,
    map: map,
    strokeColor: '#0000ff',
    fillColor: '#fab802',
    strokeWeight: 1,
    fillOpacity: 0.5,
  });
};

const placeSourceEmission = (
  map: google.maps.Map,
  point: google.maps.LatLng | google.maps.LatLngLiteral
) => {
  return new google.maps.Marker({
    position: point,
    map: map,
    icon: {
      path: google.maps.SymbolPath.CIRCLE,
      fillColor: "orange",
      fillOpacity: 0.6,
      scale: 7,
      strokeWeight: 0.75,
      strokeColor: "blue",
      anchor: new google.maps.Point(0, 0),
    },
    zIndex: 1000,
    draggable: false,
  });
};

const addCheckbox = (labelText: string, empilement: boolean, id:number, id_task:number, name_task:string, val:number) => {
  if(empilement) {
    const parentDiv = document.getElementById("expoll-impact");
    const checkboxGroup = document.createElement("div");
    checkboxGroup.className = "haut60";
    parentDiv.appendChild(checkboxGroup);
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.checked = true;
    checkbox.name = id.toString();
    checkboxGroup.appendChild(checkbox);
    checkbox.value = val.toString();
    checkbox.dataset.idAndTask = id.toString() + "_" + id_task.toString();
    const label = document.createElement("span");
    label.id = "label" + id.toString();
    label.appendChild(document.createTextNode(labelText));
    label.style.marginRight = "1em";
    checkboxGroup.appendChild(label);
    const loader = document.createElement("div");
    loader.classList.add("lds-hourglass");
    checkboxGroup.appendChild(loader);
    return checkboxGroup;  
  }
};

const displayOdorConcentration = async (
  date: string,
  time: string,
  aOdorModellingConfigId: number,
  aOdorModellingConfigValue: number
): Promise<{ location: google.maps.LatLng; weight: number }[]> => {
  // If odor_modelling_config_id is not owned by ODO, nothing is returned
  const pathname = `/Enqueteur/modelling_odor_concentration/php/ajax_odor_concentration.php?date=${date}&time=${time}&odor_modelling_config_id=${aOdorModellingConfigId}&concentration=${aOdorModellingConfigValue}`;

  const odorConcentrationPointsRaw = await fetch_utils.boilerplateGet(pathname);
  if (odorConcentrationPointsRaw === false) {
    return;
  }
  let odorConcentrationPoints: OdorConcentrationPointsRow[] = [];
  try {
    // I use JSON array instead of two `String.splits()`. It's enough for our goal.
    // Maybe parse JSON array is better than two String.splits.
    // https://www.measurethat.net/Benchmarks/Show/9634/1/jsonparse-vs-stringsplit
    // https://stackoverflow.com/questions/58279818/to-optimise-performance-should-i-store-web-data-as-csv-or-json
    // https://leanylabs.com/blog/js-csv-parsers-benchmarks/
    odorConcentrationPoints = JSON.parse(odorConcentrationPointsRaw);
  } catch (error) {
    fetch_utils.catchJsonParseError(pathname, odorConcentrationPointsRaw);
    return;
  }
  return odorConcentrationPoints.map((aPoint: OdorConcentrationPointsRow) => {
    return {
      location: new google.maps.LatLng(aPoint[0], aPoint[1]),
      weight: aPoint[2],
    };
  });
};

function getGradient(maxWeight) {
  let g;
  if(maxWeight >= 0 && maxWeight <= 0.5)
    g = gradientHeatmap1;
  else if(maxWeight > 0.5 && maxWeight <= 1)
    g = gradientHeatmap2;
  else if(maxWeight > 1 && maxWeight <= 3)
    g = gradientHeatmap3;
  else if(maxWeight > 3 && maxWeight <= 5)
    g = gradientHeatmap4;
  else if(maxWeight>5 && maxWeight <= 10)
    g = gradientHeatmap5;
  else if(maxWeight>10)
    g = gradientHeatmap6;
  return g;
}

const addPoints = async (
  map: google.maps.Map,
  date: string,
  time: string,
  aOdorModellingConfigId: number,
  aOdorModellingConfigValue: number
): Promise<google.maps.visualization.HeatmapLayer> => {
  const googleHeatmapPoints = await displayOdorConcentration(
    date,
    time,
    aOdorModellingConfigId, 
    aOdorModellingConfigValue
  );

  let maxWeight = 0;
  googleHeatmapPoints.forEach((aPoint) => {
    if (aPoint.weight > maxWeight) {
      maxWeight = aPoint.weight;
    }
  });

  // Plafond à 10 pour que tout ce qui est > 10 soit violet
  const colorCap = 10;
  
  const cappedPoints = googleHeatmapPoints.map(point => ({
    location: point.location,
    weight: Math.min(point.weight, colorCap), // Pour l'affichage des couleurs
    originalWeight: point.weight // Vraie valeur conservée
  }));

  // Utiliser le gradient complet (gradientHeatmap6) pour avoir violet au maximum
  let g = gradientHeatmap6; // Votre gradient avec violet à la fin
  
  const heatmapLayer = new google.maps.visualization.HeatmapLayer({
    data: cappedPoints,
    map: map,
    maxIntensity: colorCap,
    gradient: g,
  });

  // Stocker la vraie valeur max pour la légende
  (heatmapLayer as any).realMaxWeight = maxWeight;

  return heatmapLayer;
};

const addScale = (checkboxGroup: HTMLDivElement, maxIntensity: string) => {
  const legend = document.createElement("div");
  legend.style.height = "1em";
  legend.style.width = "100%";
  
  let g = getGradient(parseFloat(maxIntensity));

  const linearGradient = g.join(",");
  legend.style.background = `linear-gradient(to right, ${linearGradient})`;
  checkboxGroup.appendChild(legend);
  const scale = document.createElement("div");
  scale.style.display = "flex";
  scale.style.width = "100%";
  scale.style.height = "1em";
  scale.style.justifyContent = "space-between";
  const minScale = document.createElement("span");
  minScale.appendChild(document.createTextNode("0"));
  const maxScale = document.createElement("span");
  maxScale.appendChild(document.createTextNode(maxIntensity));
  scale.appendChild(minScale);
  scale.appendChild(maxScale);
  checkboxGroup.appendChild(scale);
};

const heatmapAdded = (
  heatmap: google.maps.visualization.HeatmapLayer,
  checkboxGroup: HTMLDivElement,
  map: google.maps.Map,
  empilement: boolean
) => {
  if(empilement) {
    checkboxGroup.querySelector(".lds-hourglass").remove();
    if (heatmap.getData().getLength() === 0) {
      const noPointWarnignMessage = document.createElement("div");
      noPointWarnignMessage.style.color = "green";
      noPointWarnignMessage.appendChild(
        document.createTextNode(trads.aucune_odeur)
      );
      checkboxGroup.appendChild(noPointWarnignMessage);
      return;
    }
    checkboxGroup.querySelector("input").addEventListener("change", function () {
      if (this.checked) {
        heatmapAndLabels.forEach((aHeatmapAndLabel) => {
          if(aHeatmapAndLabel.id + "_" + aHeatmapAndLabel.id_task == this.dataset.idAndTask)
            aHeatmapAndLabel.heatmap.setMap(map);
          });
        } else {
        heatmapAndLabels.forEach((aHeatmapAndLabel) => {
            if(aHeatmapAndLabel.id + "_" + aHeatmapAndLabel.id_task == this.dataset.idAndTask)
              aHeatmapAndLabel.heatmap.setMap(null);
        });
      }
    });
    const realMaxIntensity = (heatmap as any).realMaxWeight;
    addScale(checkboxGroup, String(realMaxIntensity));
  }
};

/**
 * https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
 */
const getDistanceFromLatLonInKm = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) => {
  const deg2rad = (deg: number) => deg * (Math.PI / 180);

  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

const findNearestPoint = (
  aHeatmapAndLabel: IHeatmapAndLabel,
  mapsMouseEvent: google.maps.MapMouseEvent,
  nearerWeightedLocation: IDistanceWeight
) => {
  aHeatmapAndLabel.heatmap
    .getData()
    .forEach((weightedLocation: google.maps.visualization.WeightedLocation) => {
      const distance = getDistanceFromLatLonInKm(
        mapsMouseEvent.latLng.lat(),
        mapsMouseEvent.latLng.lng(),
        weightedLocation.location.lat(),
        weightedLocation.location.lng()
      );
      if (distance < nearerWeightedLocation.distance) {
        nearerWeightedLocation.distance = distance;
        nearerWeightedLocation.weight = weightedLocation.weight;
        nearerWeightedLocation.originalWeight = (weightedLocation as any).originalWeight;
      }
    });
};

const displayValueNearer = (
  map: google.maps.Map,
  heatmapAndLabels: IHeatmapAndLabel[]
) => {
  map.addListener("click", (mapsMouseEvent: google.maps.MapMouseEvent) => {
    const labelAndWeight = heatmapAndLabels.reduce<string>(
      (accumulator, aHeatmapAndLabel): string => {
        let nearerWeightedLocation: IDistanceWeight = {
          distance: 12742,
          weight: 0,
          originalWeight: 0
        };
        
        findNearestPoint(
          aHeatmapAndLabel,
          mapsMouseEvent,
          nearerWeightedLocation
        );
        if (nearerWeightedLocation.distance < 0.05) {
          accumulator += `<br /> ${aHeatmapAndLabel.label} (${aHeatmapAndLabel.name_task}): ${nearerWeightedLocation.originalWeight} ` + uniteHTML;
        }
        return accumulator;
      },
      ""
    );
    if (labelAndWeight !== "") {
      new google.maps.InfoWindow({
        position: mapsMouseEvent.latLng,
        content: `Expoll Impact ${labelAndWeight}`,
      }).open(map);
    }
  });
};

const hideDisplayHeatmapZoom = (
  map: google.maps.Map,
  heatmapAndLabels: IHeatmapAndLabel[]
) => {
  heatmapAndLabels.forEach((aHeatmapAndLabel) => {
    const messageExpollImpactNotShown = document.getElementById(
      "expoll-impact-not-shown"
    );
    const heatmapZoom = 12;
    if (map.getZoom() < heatmapZoom) {
      aHeatmapAndLabel.heatmap.setMap(null);
      messageExpollImpactNotShown.style.display = "block";
    } else {
      aHeatmapAndLabel.heatmap.setMap(map);
      messageExpollImpactNotShown.style.display = "none";
    }
  });
};

const hideDisplayHeatmapEvent = (
  map: google.maps.Map,
  heatmapAndLabels: IHeatmapAndLabel[]
) => {
  hideDisplayHeatmapZoom(map, heatmapAndLabels);
  map.addListener("center_changed", () => {
    window.setTimeout(() => {
      hideDisplayHeatmapZoom(map, heatmapAndLabels);
    }, 3000);
  });
};

const heatmapAndLabels: IHeatmapAndLabel[] = [];

const init = async (
  map: google.maps.Map,
  date: string,
  time: string,
  traductions: ITrads,
  empilement: boolean = true
): Promise<void> => {
  trads = traductions;
  const odorModellingConfig = await getAjaxOdorModellingConfig();
  if (odorModellingConfig.length === 0) {
    alert(`No odor modelling config retrieved. Please add at least one.`);
    return;
  }

  const idConfigAndCheckbox: IIdConfigAndCheckbox[] = [];
    
  for (const aOdorModellingConfig of odorModellingConfig) {
      const productionTasksOdor = await getProductionTaskOdor(date, time, aOdorModellingConfig.id);  

      if(productionTasksOdor.length > 0) {
        for (const task of productionTasksOdor) {
          let lab = aOdorModellingConfig.label + " (" + task["lib"] + ")";
          idConfigAndCheckbox.push({
            id: aOdorModellingConfig.id,
            checkboxGroupHtml: addCheckbox(lab, empilement, aOdorModellingConfig.id, task["id"], task["lib"], task["value"]),
            label: aOdorModellingConfig.label,
            id_task: task["id"], 
            name_task: task["lib"], 
            value: task["value"]
          });
        }
      }
      else {
        let lab = aOdorModellingConfig.label + " (Par défaut)";
        idConfigAndCheckbox.push({
            id: aOdorModellingConfig.id,
            checkboxGroupHtml: addCheckbox(lab, empilement, aOdorModellingConfig.id, 0, "Par Défaut", 1),
            label: aOdorModellingConfig.label,
            id_task: 0, 
            name_task: "Par défaut", 
            value: 1
          });
      }  
    
    sourceEmission.push(
      placeSourceEmission(
        map,
        new google.maps.LatLng(
          aOdorModellingConfig.latitude,
          aOdorModellingConfig.longitude
        )
      )
    );
    let points = new Array();

    try{
      eval(aOdorModellingConfig["AreaPoints"]).forEach(point => {
        points.push(new google.maps.LatLng(point[0], point[1]));
      });
    
      areaEmission.push(
        placeAreaEmission(
          map,
          points
        )
      );
    }
    catch (error) { console.log(error); }
  }
  
  for (const aIdAndCheckbox of idConfigAndCheckbox) {
    // Let synchronous to avoid kill server by too heavy process
    const aHeatmap = await addPoints(map, date, time, aIdAndCheckbox.id, aIdAndCheckbox.value);
    heatmapAdded(aHeatmap, aIdAndCheckbox.checkboxGroupHtml, map, empilement);
    heatmapAndLabels.push({ heatmap: aHeatmap, label: aIdAndCheckbox.label, id: aIdAndCheckbox.id, id_task: aIdAndCheckbox.id_task, name_task: aIdAndCheckbox.name_task, value:aIdAndCheckbox.value});
  }
  displayValueNearer(map, heatmapAndLabels);
  hideDisplayHeatmapEvent(map, heatmapAndLabels);
};

const displaySourcesEmission = (map: google.maps.Map, display: boolean) => {
  sourceEmission.forEach((aSourceEmission) => {
    if(display) {
      aSourceEmission.setMap(map);
    } else {
      aSourceEmission.setMap(null);
    }
  })
  areaEmission.forEach((aAreaEmission) => {
    if(display) {
      aAreaEmission.setMap(map);
    } else {
      aAreaEmission.setMap(null);
    }
  })
}

export default {
  displaySourcesEmission,
  init,
  heatmapAndLabels,
  hideDisplayHeatmapZoom
}
